import React from 'react';
import './Features.css';
import seoImage from '../../../images/seo.jpg';
import paidAdsImage from '../../../images/paidads.jpg';


const featuresData = [
    {
        title: 'SEO & Search Marketing',
        description: 'Our SEO experts use cutting-edge techniques and data-driven strategies to improve your search rankings and drive qualified organic traffic to your website.',
        features: [
            'Technical SEO audits & optimization',
            'Keyword research & content strategy',
            'Link building & digital PR',
            'Local SEO & Google My Business',
            'E-commerce SEO optimization'
        ],
        ctaText: 'Boost Your Rankings'
    },
    {
        title: 'Paid Advertising',
        description: 'Maximize your advertising ROI with expertly managed campaigns across Google Ads, Facebook, LinkedIn, and other platforms. We turn ad spend into revenue.',
        features: [
            'Google Ads management',
            'Facebook & Instagram advertising',
            'LinkedIn B2B campaigns',
            'Remarketing & retargeting',
            'Shopping & display campaigns'
        ],
        ctaText: 'Start Advertising'
    },
    {
        title: 'Web Development',
        description: 'Beautiful, fast, and conversion-optimized websites that drive results. We build digital experiences that engage users and grow your business.',
        features: [
            'Custom website development',
            'E-commerce platforms',
            'Landing page optimization',
            'WordPress development',
            'Website maintenance & support'
        ],
        ctaText: 'Build Your Website'
    }
];

const Features = () => {
    return (
        <>
            {featuresData.map((feature, index) => (
                <section className="feature-section" key={index}>
                    <div className="container-wide">
                        <div className="feature-content">
                            <div className="feature-text">
                                <h2>{feature.title}</h2>
                                <p>{feature.description}</p>
                                <ul className="feature-list">
                                    {feature.features.map((item, itemIndex) => (
                                        <li key={itemIndex}>{item}</li>
                                    ))}
                                </ul>
                                <a href="#contact" className="btn btn-dark">
                                    {feature.ctaText}
                                    <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                                    </svg>
                                </a>
                            </div>
                            <div className="feature-visual">
                                {index === 0 ? (
                                    <img src={seoImage} alt={feature.title} className="feature-image" />
                                ) : index === 1 ? (
                                    <img src={paidAdsImage} alt={feature.title} className="feature-image" />
                                ) : (
                                    <div className="feature-image-placeholder">
                                        <p>🖼️ Add Feature Visual</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            ))}
        </>
    );
};

export default Features;
